import React, { useState } from 'react';

function SortableTable({ data, headers }) {
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc');

  const handleSort = (column) => {
    if (column === sortColumn) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortDirection('asc');
    }
  };

  const sortedData = data.slice().sort((a, b) => {
    if (sortColumn) {
      const aValue = a[sortColumn];
      const bValue = b[sortColumn];

      // Check if the values are numbers
      const isNumeric = !isNaN(parseFloat(aValue)) && isFinite(aValue);

      if (isNumeric) {
        return sortDirection === 'asc' ? aValue - bValue : bValue - aValue;
      } else {
        return sortDirection === 'asc'
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }
    }
    return 0;
  });

  return (
    <div className="overflow-hidden mx-auto max-w-2xl shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
        <table className="table-auto min-w-full divide-y divide-gray-300">
        <thead>
            <tr className="bg-gray-100 cursor-pointer">
            {headers.map((header) => (
                <th key={header} onClick={() => handleSort(header)} className="px-3 py-3.5 justify-center text-sm font-semibold text-gray-900">
                {header} {sortColumn === header && (sortDirection === 'asc' ? '▲' : '▼')}
                </th>
            ))}
            </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 bg-white">
            {sortedData.map((row, index) => (
            <tr key={index}>
                {headers.map((header) => (
                <td key={header} className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{row[header]}</td>
                ))}
            </tr>
            ))}
        </tbody>
        </table>
    </div>
  );
}

export default SortableTable;
